import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select"
import * as moment from "moment"
import { getAllBanks as onGetAllBanks } from "store/products/actions"
import { getAllCoas as onGetAllCoa } from "store/products/actions"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { showSuccessToast } from "helpers/function_helper"


const AddNewBank = props => {

  const typeOptions = [
    {
      label: "Current",
      value: "current"
    },{
      label: "Savings",
      value: "savings"
    },{
      label: "Loan Account",
      value: "loanacc"
    },{
      label: "Over Draft",
      value: "overdraft"
    },{
      label: "Cash Credit",
      value: "cashcredit"
    },{
      label: "Credit Card",
      value: "creditcard"
    }
  ]

  const dispatch = useDispatch()

  const [validation, setValidation] = useState({
    type: null,
    displayName: null,
    bankName: null,
    branchName: null,
    accountNo: null,
    accountName: null,
  })

  const mandatoryFields = ['type','displayName','bankName','branchName','accountNo','accountName']

  const [showLoading, setShowLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  
  const [displayName, setDisplayName] = useState('')
  const [bankName, setBankName] = useState('')
  const [branchName, setBranchName] = useState('')
  const [accountNo, setAccountNo] = useState('')
  const [accountName, setAccountName] = useState('')
  const [ifscCode, setIfscCode] = useState('')
  const [coaRefId, setCoaRefId] = useState('')
  const [type, setType] = useState(typeOptions[0])
  const [id, setId] = useState('')
  const [description, setDescription] = useState('')

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('inp-type-id').focus();
    }, 250);
    if(props.enteredText != ''){
      setDisplayName(props.enteredText)
    }
  }, [props.enteredText])

  useEffect(() => {
    if(props.isEdit){
      setDisplayName(props.detailsForEdit.displayName)
      setBankName(props.detailsForEdit.bankName)
      setBranchName(props.detailsForEdit.branchName)
      setAccountNo(props.detailsForEdit.accountNo)
      setAccountName(props.detailsForEdit.accountName)
      setIfscCode(props.detailsForEdit.ifscCode)
      setCoaRefId(props.detailsForEdit.coaRefId)
      if(props.detailsForEdit.type && props.detailsForEdit.type != ''){
        const salType = typeOptions.filter(each => each.value == props.detailsForEdit.type)
        if(salType && salType.length == 0){
          setType(salType[0])
        }
      }
      setId(props.detailsForEdit.id)
      setDescription(props.detailsForEdit.description)
    }
  }, [props.detailsForEdit])

  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }
  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if(mandatoryFields.includes(fieldName)){
      const modifiedV = { ...validation }
      if (value !== "") {
        modifiedV[fieldName] = true
      } else {
        modifiedV[fieldName] = false
      }
      setValidation(modifiedV)
    }
  }

  function validateForm() {
    const modifiedV = { ...validation }
    let formValid = true;
    if(displayName && displayName != ""){
      modifiedV["displayName"] = true
    }
    else{
      modifiedV["displayName"] = false
      formValid = false
    }

    if(bankName && bankName != ""){
      modifiedV["bankName"] = true
    }
    else{
      modifiedV["bankName"] = false
      formValid = false
    }

    if(branchName && branchName != ""){
      modifiedV["branchName"] = true
    }
    else{
      modifiedV["branchName"] = false
      formValid = false
    }

    if(type && type != ""){
      modifiedV["type"] = true
    }
    else{
      modifiedV["type"] = false
      formValid = false
    }

    if(accountNo && accountNo != ""){
      modifiedV["accountNo"] = true
    }
    else{
      modifiedV["accountNo"] = false
      formValid = false
    }

    if(accountName && accountName != ""){
      modifiedV["accountName"] = true
    }
    else{
      modifiedV["accountName"] = false
      formValid = false
    }

    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    const formValid = validateForm()
    if(formValid){
      setShowLoading(true)
      const response = await onAddItemDirect({
        'displayName' : displayName,
        'bankName' : bankName,
        'branchName' : branchName,
        'accountNo' : accountNo,
        'accountName' : accountName,
        'ifscCode' : ifscCode,
        'coaRefId' : coaRefId,
        'type' : type.value,
        'description' : description,
      }, 'Bank')

      setShowLoading(false)
      if(response.status == 'success'){
        dispatch(onGetAllBanks())
        dispatch(onGetAllCoa(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    const formValid = validateForm();
    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
          'id': id,
          'displayName': displayName,
          'bankName' : bankName,
          'branchName' : branchName,
          'accountNo' : accountNo,
          'accountName' : accountName,
          'ifscCode' : ifscCode,
          'coaRefId' : coaRefId,
          'description' : description,
          'type' : type.value,
        }, 'Bank')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetAllBanks())
        dispatch(onGetAllCoa(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  return (
    <React.Fragment>
      <div className="">
        <Container fluid={true} className="min-height-700">
          <Row>
            <Col lg="12">
              <Card  style={{paddingBottom: (window.screen.height/2) +"px"}}>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="type">
                              Type *
                            </Label>
                            <Select
                              onChange={(e) => {
                                setType(e)
                              }}
                              value={type}
                              options={typeOptions}
                              classNamePrefix="select2-selection"
                              isLoading={false}
                              id="inp-type-id"
                            />
                            {(validation["type"] === false) &&
                              <div className="custom-error">
                                Please select the type
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="displayname">
                              Ledger Display Name *
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="displayname"
                              maxLength="50"
                              value={displayName || ''}
                              onChange={event => {
                                onChangeValidation("displayName", event.target.value.trim())
                                setDisplayName(event.target.value)
                              }}
                              invalid={
                                validation["displayName"] !== true &&
                                validation["displayName"] !== null
                              }
                            />
                            {(validation["displayName"] === false) &&
                              <div className="custom-error">
                                Please enter the Ledger Name
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="bankName">
                              Bank Name *
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="bankName"
                              maxLength="50"
                              value={bankName || ''}
                              onChange={event => {
                                onChangeValidation("bankName", event.target.value.trim())
                                setBankName(event.target.value)
                              }}
                              invalid={
                                validation["bankName"] !== true &&
                                validation["bankName"] !== null
                              }
                            />
                            {(validation["bankName"] === false) &&
                              <div className="custom-error">
                                Please enter the Bank Name
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="branchName">
                              Branch *
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="branchName"
                              maxLength="50"
                              value={branchName || ''}
                              onChange={event => {
                                onChangeValidation("branchName", event.target.value.trim())
                                setBranchName(event.target.value)
                              }}
                              invalid={
                                validation["branchName"] !== true &&
                                validation["branchName"] !== null
                              }
                            />
                            {(validation["branchName"] === false) &&
                              <div className="custom-error">
                                Please enter the Branch
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="accountNo">
                              Account No *
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="accountNo"
                              maxLength="20"
                              value={accountNo || ''}
                              onChange={event => {
                                onChangeValidation("accountNo", event.target.value.trim())
                                setAccountNo(event.target.value)
                              }}
                              invalid={
                                validation["accountNo"] !== true &&
                                validation["accountNo"] !== null
                              }
                            />
                            {(validation["accountNo"] === false) &&
                              <div className="custom-error">
                                Please enter the Account Number
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="accountName">
                              Account Name *
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="accountName"
                              maxLength="50"
                              value={accountName || ''}
                              onChange={event => {
                                onChangeValidation("accountName", event.target.value.trim())
                                setAccountName(event.target.value)
                              }}
                              invalid={
                                validation["accountName"] !== true &&
                                validation["accountName"] !== null
                              }
                            />
                            {(validation["accountName"] === false) &&
                              <div className="custom-error">
                                Please enter the Account Name
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="ifscCode">
                              IFSC Code
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="ifscCode"
                              maxLength="20"
                              value={ifscCode || ''}
                              onChange={event => {
                                onChangeValidation("ifscCode", event.target.value.trim())
                                setIfscCode(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="description">
                              Description
                            </Label>
                            <textarea
                              id="description"
                              className="form-control"
                              rows="2"
                              maxLength="150"
                              value={description || ''}
                              onChange={e => {
                                onChangeValidation("description", e.target.value.trim())
                                setDescription(engine.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-5">
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                SAVE
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewBank.propTypes = {
  newlyAddedValue: PropTypes.func,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool,
  enteredText:PropTypes.any,
}

export default AddNewBank
